export default __webpack_public_path__ + "static/media/cloudwatch-alarm.c5e4c09e.svg";